import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/buttons/button";
import { TextInput } from "../../../../components/inputs/textInput";
import { InfoComponent } from "../../../../components/notification/infoComponent";
import { AuthHeader } from "../../../../components/typography/authHeader";
import { useAdminLoginMutation } from "../../../../redux/features/admin/auth/auth.api";
import { authSliceActions } from "../../../../redux/features/auth/auth.slice";
import { useAppDispatch } from "../../../../redux/hooks";
import { BaseApiErrorResponse } from "../../../../utils/types";
import { SignInSchema } from "../../../../utils/validations";

export const AdminLoginPage = () => {
  const [login, { isLoading, isError, error }] = useAdminLoginMutation();

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema: SignInSchema,
      onSubmit: async (vals) => {
        const response = await login({
          email: vals.email,
          password: vals.password,
        });

        if (response.data?.status === "success") {
          dispatch(
            authSliceActions.signAdminIn({
              profile: {
                ...response.data.data,
              },
              token: response.data.data.token,
            }),
          );

          navigate("/users");
        }
      },
    });

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <AuthHeader
        header="Admin Login"
        text={<span>Welcome to Tikket Backoffice.</span>}
      />

      <div className="mt-10 flex flex-col gap-5">
        {isError && (
          <InfoComponent
            title="Error"
            text={
              (error as unknown as BaseApiErrorResponse)?.data?.message ??
              "An error occurred!"
            }
            type="error"
          />
        )}

        <TextInput
          type="text"
          name="email"
          value={values.email}
          placeholder="e.g. example@email.com"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Email"
          errors={errors.email && touched.email ? errors.email : ""}
          autoFocus
          autoFocusOnMobile={false}
        />

        <TextInput
          type="password"
          name="password"
          value={values.password}
          placeholder="Enter your password"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Password"
          errors={errors.password && touched.password ? errors.password : ""}
        />

        <Link
          to={`/forgot-password${!errors.email ? `?email=${encodeURIComponent(values.email)}` : ""}`}
          className="text-sm font-bold text-grey-700"
        >
          Forgot Password?
        </Link>

        <Button
          type="submit"
          text="Log in"
          variation="primary"
          className="mt-5"
          loading={isLoading}
          disabled={isLoading}
        />
      </div>
    </form>
  );
};
